module.exports = __webpack_public_path__ + "img/work-flow.e3ea97d5.svg";